import React from "react";
import "./Google.css";
import GoogleTranslate from "./GoogleTranslateComponent";
import { useSelector } from "react-redux";
import { selectSiteData } from "../store/selectors/commonSelectors";


const Google = () => {
      const siteData = useSelector(selectSiteData);      
    return (
        <div className="translate">
            <div className="translate-left">
                <GoogleTranslate />
            </div>
            <div className="translate-right">
                <a href="mailto:sales@akinex.com" className="translate-email">
                   {siteData?.email}
                </a>
            </div>
        </div>
    );
};

export default Google;